export default __webpack_public_path__ + "static/media/tokenomics_back.441e8152.png";